export default {"src":"/_next/static/media/InternalLinkingAI.8c19b103.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};